module.exports = __webpack_public_path__ + "img/expression7.4b237569.png";